import { useRef, useState } from "react";

import { FormikProps } from "formik";

/**
 * A panel's edit form: its Formik ref and the unsaved-changes confirm.
 * `isEditing` is the panel's own toggle for panels that keep that state
 * locally; the task panel reads it from the URL instead and ignores it.
 */
export function usePanelState<T extends object = object>() {
	const [isEditing, setIsEditing] = useState(false);
	const formRef = useRef<FormikProps<T> | null>(null);
	const [showConfirmModal, setShowConfirmModal] = useState(false);

	const makeActions = (onClose: () => void) => ({
		onSave: () => formRef.current?.submitForm(),
		onCancel: () => {
			if (!formRef.current?.dirty) {
				setIsEditing(false);
				onClose();
			} else {
				setShowConfirmModal(true);
			}
		},
		onDiscard: () => {
			setShowConfirmModal(false);
			setIsEditing(false);
			onClose();
		},
		onKeepEditing: () => setShowConfirmModal(false),
	});

	return { isEditing, setIsEditing, formRef, showConfirmModal, makeActions };
}
